export function getStatusFilterOptions(t) {
  return [
    { value: "all", label: t("dashboard.common.allStatus") },
    { value: "approved", label: t("dashboard.status.completed") },
    { value: "pending", label: t("dashboard.status.pending") },
    { value: "rejected", label: t("dashboard.status.canceled") },
  ];
}

export function getDateRanges(t) {
  return [
    { value: "7", label: t("dashboard.common.last7Days"), days: 7 },
    { value: "30", label: t("dashboard.common.last30Days"), days: 30 },
    { value: "90", label: t("dashboard.common.last90Days"), days: 90 },
  ];
}

export function getShowingText(t, { entity, start, end, total }) {
  if (total === 0) {
    return t(`dashboard.common.showingZero.${entity}`);
  }
  return t("dashboard.common.showingRange", {
    start,
    end,
    total: total.toLocaleString(),
    entity: t(`dashboard.entities.${entity}`),
  });
}

export function translateOrderStatus(t, status) {
  const key = String(status || "").toLowerCase();
  const map = {
    pending: t("dashboard.status.pending"),
    approved: t("dashboard.status.completed"),
    rejected: t("dashboard.status.canceled"),
  };
  return map[key] ?? (status ? String(status).toUpperCase() : "—");
}

export function translateEsimStatus(t, status) {
  const key = String(status || "").toLowerCase();
  const map = {
    in_service: t("dashboard.status.active"),
    terminated: t("dashboard.status.expired"),
    pre_service: t("dashboard.status.pending"),
    waiting_for_assignment: t("dashboard.status.pending"),
    pending: t("dashboard.status.pending"),
    approved: t("dashboard.status.completed"),
    rejected: t("dashboard.status.canceled"),
  };
  return map[key] ?? (status ? String(status).toUpperCase() : "—");
}

export function translateGenericStatus(t, status) {
  if (!status) return "—";
  const key = String(status).toLowerCase();
  const translated = t(`dashboard.status.${key}`, { defaultValue: "" });
  if (translated) return translated;
  return String(status).replace(/_/g, " ").toUpperCase();
}
